import { render, staticRenderFns } from "./SpecialOfferItemLeft.vue?vue&type=template&id=3a710b13&scoped=true&"
import script from "./SpecialOfferItemLeft.vue?vue&type=script&lang=js&"
export * from "./SpecialOfferItemLeft.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOfferItemLeft.vue?vue&type=style&index=0&id=3a710b13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a710b13",
  null
  
)

export default component.exports